<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <h4 class="mr-sm-4 mb-3 header-tablepage">REP - Repair Product</h4>

      <b-tabs content-class="py-3" v-model="tabIndex">
        <b-tab
          v-for="status of statusList"
          :key="status.id"
          :value="status.id"
          @click="onTabChange(status.repairStatusId, $event)"
        >
          <template #title>
            {{ status.name }}
            <b-badge pill>
              {{ status.count }}
              <span class="sr-only">count items list</span></b-badge
            >
          </template>
          <div class="d-flex justify-content-between mb-2">
            <InputText
              v-model="filter.search"
              type="text"
              faIcon="search"
              className="mb-2 bg-second w-50"
              placeholder="ค้นหาเลขที่เอกสาร"
              @onClickIcon="onSearch"
              @onEnter="onSearch"
            />
            <b-button
              class="bg-main bt-height"
              :disabled="isLoading"
              @click="goDetail(0)"
              ><font-awesome-icon icon="plus" class="mr-0 mr-sm-1" />
              สร้าง
            </b-button>
          </div>
          <b-table
            striped
            hover
            :busy="isBusy"
            :items="items"
            :fields="fields"
            show-empty
            empty-text="No matching records found"
          >
            <template v-slot:cell(request_branch_name)="{ item }">
              <div class="text-center text-black my-2">
                {{ item.request_branch_code }} {{ item.created_by_name }}
                <br />
                <span class="text-gray">{{ item.request_branch_name }}</span>
              </div>
            </template>

            <template v-slot:cell(remark)="{ item }">
              {{ item.remark || "-" }}
            </template>
            <template v-slot:cell(repairStatusName)="{ item }">
              <div class="text-center">
                <p>{{ item.repairStatusName || "-" }}</p>
                <p
                  v-if="item.repair_status_id == 2"
                  :class="{
                    'text-success':
                      item.paymentStatusName == 'ชำระเงินแล้ว' ||
                      item.paymentStatusName == 'ส่งมอบแล้ว',
                    'text-danger':
                      item.paymentStatusName == 'ยังไม่ชำระเงิน' ||
                      item.paymentStatusName == 'ยังไม่ส่งมอบ',
                  }"
                >
                  ({{ item.paymentStatusName }})
                </p>
              </div>
            </template>
            <template v-slot:cell(document_no)="{ item }">
              <div
                class="text-link my-2"
                @click="$router.push(`/repair-product/detail/${item.id}`)"
              >
                {{ item.document_no }}
              </div>
            </template>
            <template v-slot:cell(created_time)="data">
              <div class="text-center text-black my-2">
                {{ $moment(data.item.created_time).format("DD/MM/YYYY") }}
                <!-- <br />
                {{ $moment(data.item.created_time).format("HH:mm:ss") }} -->
              </div>
            </template>
            <template v-slot:cell(expect_finish_date)="data">
              <div class="text-center text-black my-2">
                {{ $moment(data.item.expect_finish_date).format("DD/MM/YYYY") }}
                <!-- <br />
                {{ $moment(data.item.expect_finish_date).format("HH:mm:ss") }} -->
              </div>
            </template>
            <template v-slot:cell(action)="data">
              <font-awesome-icon
                icon="edit"
                  class="edit pointer text-warning"
                @click="$router.push(`/repair-product/detail/${data.item.id}`)"
            /></template>
            <template v-slot:cell(billNo)="{ item }">
              <div
                v-if="item.billNo"
                class="text-link my-2 "
                @click="
                  $router.push(
                    `/transaction/detail/${item.repair_user_transaction_id}/${item.repair_owner_user_guid}/1`
                  )
                "
              >
                {{ item.billNo }}
              </div>

              <div v-else>-</div>
            </template>
            <template v-slot:table-busy>
              <div class="text-center text-black my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="ml-2">Loading...</strong>
              </div>
            </template>
          </b-table>
          <Pagination
            @handleChangeTake="handleChangeTake"
            :pageOptions="pageOptions"
            :filter="filter"
            :rows="rows"
            @pagination="pagination"
          />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import HeaderPanel from "@/components/HeaderPanel";
import Pagination from "@/components/Pagination";
import InputText from "@/components/inputs/InputText";

import { mapGetters } from "vuex";

export default {
  components: {
    OtherLoading,
    Pagination,
    HeaderPanel,
    InputText,
  },
  name: "Inventory",
  data() {
    return {
      fields: [
        {
          key: "created_time",
          label: "วันที่",
          thStyle: { width: "10%" },
        },
        {
          key: "document_no",
          label: "เลขที่เอกสาร",
          thStyle: { width: "10%" },
        },

        {
          key: "name",
          label: "สินค้า",
          thStyle: { width: "10%" },
        },

        {
          key: "serial",
          label: "Serial",
          thStyle: { width: "10%" },
        },
        {
          key: "expect_finish_date",
          label: "กำหนดรับ",
          thStyle: { width: "10%" },
        },
        {
          key: "repair_send_user_name",
          label: "ผู้ส่งซ่อม",
          thStyle: { width: "20%" },
        },
        {
          key: "repairStatusName",
          label: "สถานะ",
          tdClass: "text-center",
          thStyle: { width: "10%" },
        },
        {
          label: "Invoice No.",
          key: "billNo",
        },
        {
          key: "remark",
          label: "หมายเหตุ",
          tdClass: "text-center",
          thStyle: { width: "10%" },
        },
        {
          key: "action",
          label: "Action",
          tdClass: "text-center",
          thStyle: { width: "10%" },
        },
      ],
      items: [],
      isBusy: false,
      rows: 0,
      showing: 1,

      filter: {
        search: "",
        page: 1,
        take: 10,
        status: 0,
      },
      tabIndex: 0,
      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],

      isLoading: true,
      statusList: [],
    };
  },
  computed: {
    ...mapGetters({
      branchId: "getBranchId",
    }),
  },
  created: async function () {
    await this.getList(0);
    await this.getStatus();
  },
  methods: {
    getList: async function () {
      this.isBusy = true;
      let payload = { ...this.filter };

      await this.axios
        .post(`${this.$baseUrl}/repair/List`, payload)
        .then((data) => {
          this.isLoading = false;
          if (data.result == 1) {
            this.items = data.detail.datas;
            this.rows = data.detail.count;
          }
        });

      this.isBusy = false;
    },
    getStatus: async function () {
      this.isBusy = true;
      let payload = { ...this.filter };

      await this.axios
        .post(`${this.$baseUrl}/repair/StatusWithCount`, payload)
        .then((data) => {
          this.isLoading = false;
          if (data.result == 1) {
            this.statusList = data.detail.datas;
          }
        });

      this.isBusy = false;
    },
    handleSearch(value) {
      this.pagination(1);
    },
    pagination(page) {
      this.filter.page = page;
      this.$emit("filterPage", this.filter);
      this.getList();
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.$emit("filterPage", this.filter);
      this.getList();
    },

    onTabChange(val, e) {
      this.filter.status = val;
      this.filter.page = 1;
      this.getList();
    },
    onSearch() {
      this.getList();
    },
    goDetail(id) {
      this.$router.push(`/repair-product/detail/${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.bt-height {
  height: 35px !important;
}
.header-tablepage {
  color: var(--primary-color) !important;
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
}

.text-underline {
  text-decoration: underline;
  cursor: pointer;
}
</style>
